import AuthHeader from "components/AuthHeader";
import NonAuthLayoutWrapper from "components/NonAutnLayoutWrapper";
import { Alert, Button, Col, Row, Util } from "reactstrap";
import { motion } from "framer-motion";
import { ReactNode, useEffect, useState, useRef } from "react";
import OtpInput from '../../components/OtpInput'
import Loader from "components/Loader";
import { Form, Navigate, Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { APIClient } from "api/apiCore";
import { getOtp, OtpStruct, verifyOtp, UserStruct, regisNewCus, getCurrentUser } from "api/auth"
import TextBox from "components/TextBox";
import CountdownContainer from "components/CountdownContainer";
import SpinnerLink from "components/SpinnerLink";
import UserProfile from "pages/Dashboard/Settings/UserProfile";
import { setCurrentUser } from "../../redux/profile2/p2_reducer";
import { useRedux } from "../../hooks/index";
import { useMutationState } from "@tanstack/react-query";
import { Const } from "const";
import { CurUser, Utils } from "helpers/utils";
import { createSelector } from "reselect";

declare function isPWAInstalled(): boolean;
declare function installPwa(): boolean;

const RegisterByPhone = () => {
    const { dispatch, useAppSelector } = useRedux();
    const [isRegisterStage, setIsRegisterStage] = useState(true);
    const [inviteCode, setInviteCode] = useState<any>('');
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otpRefNo, setOtpRefNo] = useState('');
    const [nickName, setNickName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [groupInviteCode, setGroupInviteCode] = useState('');
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [inviterInfo, setInviterInfo] = useState<any>(null);
    const location = useLocation();
    const navigate = useNavigate();

    const errorData = createSelector(
        (state: any) => state.Profile2,
        (pf2) => ({
            isFakeSms: pf2.isFakeSms,
        })
    );

    const {isFakeSms } = useAppSelector(errorData);

    // const [otp, setOtp] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const otpLength = 6;

    const logo = () => {
        // let url = "https://w7.pngwing.com/pngs/645/1000/png-transparent-create-account-illustration-thumbnail.png";
        let url = "/icons/login_mobile.png";
        switch (step) {
            // case 1: url = "https://w7.pngwing.com/pngs/645/1000/png-transparent-create-account-illustration-thumbnail.png"; break;
            // case 2: url = "https://thumbs.dreamstime.com/b/otp-one-time-password-step-authentication-data-protection-internet-security-concept-otp-one-time-password-step-authentication-data-254434939.jpg"; break;
            // case 3: url = "https://static.vecteezy.com/system/resources/thumbnails/023/520/618/small_2x/3d-id-card-icon-identification-card-with-check-mark-isolated-on-transparent-approve-identity-verification-card-human-resources-plastic-driver-license-verify-identity-concept-3d-rendering-png.png"; break;
            case 1: url = "/icons/login_mobile.png"; break;
            case 2: url = "/icons/login_otp.png"; break;
            case 3: url = "/icons/login_info.png"; break;
        }
        if (url == "/icons/login_mobile.png" && isRegisterStage) {
            url = "/icons/login_info.png";
        }

        return <img className="pb-2" width={200} height={200} src={url}></img>
    }

    const err = (e: string) => { setErrorMessage(e); return false; }

    useEffect(() => {
        if (step == 2) {
            let t = document.getElementById('txt_otp_0') as HTMLInputElement;
            t?.focus();
            t?.select();
        }
    }, [step]);

    useEffect(() => {
        if (shouldRedirect) {
            // console.log('redirect');
            setLoading(true);

            getCurrentUser()
                .then((resp) => {
                    //console.log('getCurrentUser() Response:', resp);
                    if (resp.success) {
                        dispatch(setCurrentUser(resp.data as UserStruct));
                        // localStorage.setItem("_debug_01", JSON.stringify(resp.data));
                        Utils.JwtTokenSet(resp.tag);
                        navigate('/dashboard');
                    } else {
                        setErrorMessage(resp.message);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setErrorMessage((error as any).message);

                });

            // setErrorMessage("กำลังพาท่านเข้าระบบ กรุณารอซักครู่");
            //navigate('/dashboard'); // Use the navigate function to redirect
        }
    }, [shouldRedirect]);

    useEffect(() => {
        const queryParms = new URLSearchParams(location.search);
        const qLogin = queryParms.get("login");
        const qInvCode = queryParms.get("iv");
        setInviteCode(qInvCode);
        if (qLogin == '1') {
            setIsRegisterStage((prev) => false);
        } else {
            setIsRegisterStage((prev) => true);
        }

        // 20251031 check if its from line
        const qError = queryParms.get("error");
        const qInfo = queryParms.get("info");
        const qToken = queryParms.get("token");
        if (qInfo) { // from line
            if (qInfo == "ok" && qToken) {
                setErrorMessage("กำลังพาท่านเข้าระบบ กรุณารอ");
                Utils.JwtTokenSet(qToken);
                setShouldRedirect(true);
            }
        }
        if (qError) {
            setErrorMessage(qError);
        }

    }, [location]);


    useEffect(() => { // 20251015 check if open this page and have jwt in storage, means user already login but may press back to login page. So redirect to dashboard
        // console.log('check jwt on open the page');
        try {
            const token = Utils.JwtTokenGet();
            // const authUser = localStorage.getItem("authUser");
            const authUser = CurUser.GetAuthUserFromLocal();
            if (token != null && token != '' && authUser) { // means user 
                // console.log('check jwt on open the page, redirect to dashbaord');
                navigate('/dashboard');
            }
        } catch (e) {
            console.error(e);
        }
    }, []);

    const handleNext = async (direction: number, otpValue?: string) => {
        // console.log('handleNext');
        setErrorMessage(''); // reset
        setOtpRefNo('');
        if (direction > 0) { // next
            if (step === 1) { // input phone number and then click next
                const phoneRegex = /^[0-9]{10}$/;
                if (!phoneNumber) return err('กรุณาระบุเบอร์โทรศัพท์');
                if (!phoneRegex.test(phoneNumber)) return err('กรุณาระบุเบอร์โทร 10 หลักเป็นตัวเลข');
                try {
                    await fnGetOtp(false);
                } catch (e) {
                    console.error(e);
                    setErrorMessage((e as Error).message);
                }
            } else if (step === 2) { // verify otp
                let otp = otpValue ?? fnGetOtpFromInput();
                if (otp.length != otpLength) return err('รหัส OTP ยังไม่ครบ');
                try {
                    await fnVerifyOtp(otp);
                } catch (e) {
                    setErrorMessage((e as Error).message);
                }
                // console.log(otp);
                //console.log('OTP:', otp);
                // You would handle OTP verification here

            } else if (step === 3) { // start use the program
                if (nickName.trim() == "") return err('กรุณาระบุชื่อเล่น เพื่อใช้แสดงในการติดต่อ');
                if (Const.MUST_SPECIFIC_INVITE_CODE_WHEN_REGISTER) {
                    if (!groupInviteCode || groupInviteCode.trim() == "") return err('กรุณาระบุรหัสห้องแชท หรือ รหัสเซลล์');
                }
                try {
                    fnApplyRegister();
                } catch (e) {
                    setErrorMessage((e as Error).message);
                }
            }
            //setStep((prev) => prev + 1);
        } else { // prev
            setStep((prev) => prev - 1);
        }
    };

    const fnApplyRegister = async () => {
        //console.log('fnApplyRegister - start');
        setLoading(true);
        const data: any = {
            mobileNo: phoneNumber, nickName: nickName,
            firstName: firstName, lastName: lastName,
            companyName: companyName, groupInviteCode: groupInviteCode
        };
        const res = await regisNewCus(data);
        // console.log('fnApplyRegister:', res);
        if (!res.success) {
            setErrorMessage(res.message);
        } else {
            setErrorMessage('กรุณารอซักครู่ ระบบกำลังพาท่านเข้าสู่หน้าจอการทำงานหลัก');
            dispatch(setCurrentUser(res.data as UserStruct));
            Utils.JwtTokenSet(res.tag);
            setShouldRedirect(true);
        }
        setLoading(false);
    }



    const fnVerifyOtp = async (otp: string) => {
        setLoading(true);
        const res = await verifyOtp(phoneNumber, otp, isRegisterStage, inviteCode);
        // console.log('fnVerifyOtp:', res);

        if (res.err) {
            setErrorMessage(res.err);
        } else {
            if (res.message === Const.VERIFY_OTP_MSG && res.data) {
                setErrorMessage('กรุณารอซักครู่ ระบบกำลังพาท่านเข้าสู่หน้าจอการทำงานหลัก');
                setCurrentUser(res.data as UserStruct);
                Utils.JwtTokenSet(res.tag); // 20250708
                setShouldRedirect(true);
            } else if (res.message == Const.VERIFY_OTP_NEWCUS_WITH_INVITE && res.data) {
                setInviterInfo(res.data);
                setCompanyName(res.data.displayName);
                setGroupInviteCode(res.data.groupInviteCode);
                setStep((prev) => prev + 1);
            } else {
                if (isRegisterStage) { // if register then go next step
                    setStep((prev) => prev + 1);
                } else {  // if login then redirect to page
                    if (res.message === Const.VERIFY_OTP_NEWCUS_WITHOUT_INVITE) { // login but not yet have account, then go to register step
                        setStep((prev) => prev + 1);
                    } else {
                        setErrorMessage('กรุณารอซักครู่ ระบบกำลังพาท่านเข้าสู่หน้าจอการทำงานหลัก');
                        // await sleep(5000);
                        setCurrentUser(res.data as UserStruct);
                        Utils.JwtTokenSet(res.tag); // 20250708
                        setShouldRedirect(true);
                    }
                }
            }
            /*
            if (isRegisterStage) { // if register then go next step
                setStep((prev) => prev + 1);
            } else {  // if login then redirect to page
                setErrorMessage('กรุณารอซักครู่ ระบบกำลังพาท่านเข้าสู่หน้าจอการทำงานหลัก');
                // await sleep(5000);
                setCurrentUser(res.data as UserStruct);
                setShouldRedirect(true);
            }
                */
        }

        setLoading(false);

    }

    const sleep = (ms: number): Promise<void> => {
        return new Promise(resolve => setTimeout(resolve, ms));
    };

    const fnGetOtp = async (bResend: boolean) => {
        try {
            setLoading(true);
            // console.log('send otp to ' + phoneNumber);
            const res = await getOtp(phoneNumber, isRegisterStage, inviteCode);// await new APIClient().fnPost("/auth-register-phone-get-otp", { mobileNo: phoneNumber });
            if (res.err) {
                setErrorMessage(res.err);
            } else {
                //console.log('otp res:', res);
                setOtpRefNo(res.refno);
                if (bResend == false) {
                    setStep((prev) => prev + 1);
                } else {
                    if (countdownRef.current) {
                        countdownRef.current.resetCountdown(); // Call the resetCountdown method
                    }
                }
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            throw e;
        }
    }

    const fnGetOtpFromInput = () => {
        let optArr = new Array();
        for (let i = 0; i < otpLength; ++i) {
            optArr.push((document.getElementById('txt_otp_' + i) as HTMLInputElement).value);
        }
        let otpRs = optArr.join('');
        return otpRs;
    }

    const handleOtpChange = (otp2: string, index: number) => {
        if (step === 2 && otp2.length == otpLength && index === 5) {
            handleNext(1, otp2);
        }
    };

    const countdownRef = useRef<{ resetCountdown: () => void }>(null); // Create a ref

    const onResendOtp = async () => {
        setErrorMessage('');
        // Simulate an asynchronous operation (e.g., API call)
        return new Promise<void>((resolve) => {
            fnGetOtp(true);
            resolve();
            // setTimeout(() => {
            //     console.log("Operation completed!");
            //     resolve();
            // }, 2000); // Simulate a 2-second operation
        });
    };


    return (
        <NonAuthLayoutWrapper>
            <Row className=" justify-content-center my-auto">
                <Col sm={8} lg={6} xl={5} className="col-xxl-4 position-relative">
                    {errorMessage && (<Alert color="danger">{errorMessage}</Alert>)}
                    {loading && (<Loader></Loader>)}
                    {step === 1 && (
                        <motion.div
                            key={"step" + step}
                            initial={{ x: '100%', opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: '100%', opacity: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className="text-center">{logo()}</div>
                            {/* <h3>{isRegisterStage ? "สมัครใช้บริการ (สำหรับลูกค้า)" : "เข้าใช้งานระบบ"}</h3> */}
                            <h3><i className="fas fa-mobile-alt"></i>&nbsp;{isRegisterStage ? "สมัครใช้บริการ (สำหรับลูกค้า)" : "เบอร์โทรศัพท์"}</h3>
                            <p>ระบุเบอร์โทรศัพท์เพื่อรับรหัส:</p>

                            <TextBox
                                type="tel" className="form-control"
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                onEnter13={() => handleNext(1)}
                                placeholder="หมายเลขโทรศัพท์"
                                style={{ width: '100%', padding: '8px', marginBottom: '20px' }}
                            />

                            <div className="row">
                                <div className="col">
                                    <Button color="primary" className="w-100 waves-effect waves-light" disabled={loading} onClick={() => handleNext(1)}>
                                        รับรหัส {isFakeSms && (<>FAKE </>)}OTP
                                    </Button>
                                </div>
                            </div>
                        </motion.div>
                    )}

                    {step === 2 && (
                        <motion.div
                            key={"step" + step}
                            initial={{ x: '100%', opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: '100%', opacity: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className="text-center">{logo()}</div>
                            <h3>รหัส OTP</h3>
                            <p>ระบุรหัส OTP [REF:{otpRefNo}]<br />ที่ได้รับในมือถือ {phoneNumber} :</p>

                            <div className="pb-2">
                                <CountdownContainer ref={countdownRef} initialSeconds={60} waitText="กรุณาเช็ครหัสในมือถือที่ระบุ" textPrefix="ไม่ได้รับรหัส? ส่งใหม่ใน" textSuffix="วินาที">
                                    <SpinnerLink caption="ส่ง OTP อีกครั้ง" captionProcess="กำลังส่ง..." onClick={onResendOtp}></SpinnerLink>
                                </CountdownContainer>
                                <OtpInput length={otpLength} onChange={handleOtpChange} ></OtpInput>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <Button color="light" className="w-100 waves-effect waves-light" onClick={() => handleNext(-1)}>ย้อนกลับ</Button>
                                </div>

                                <div className="col">
                                    <Button color="primary" className="w-100 waves-effect waves-light" onClick={() => handleNext(1)}>ยืนยันรหัส</Button>
                                </div>
                            </div>
                        </motion.div>
                    )}

                    {step === 3 && (
                        <motion.div
                            key={"step" + step}
                            initial={{ x: '100%', opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: '100%', opacity: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className="text-center">{logo()}</div>
                            {/* <h3>พร้อมใช้งาน</h3> */}
                            <h3>ยินดีต้อนรับ ลูกค้าใหม่</h3>
                            <h5><i className="fas fa-phone"></i>{Utils.FormatPhoneNo10(phoneNumber)}</h5>
                            <p>กรุณาระบุรายละเอียด เพื่อใช้ในการติดต่อสื่อสาร:</p>

                            <TextBox
                                type="text" className="form-control"
                                value={nickName}
                                onChange={(e) => setNickName(e.target.value)}
                                onEnter13={() => handleNext(1)}
                                placeholder="*ชื่อเล่น"
                                style={{ width: '100%', padding: '8px', marginBottom: '20px' }}
                            />

                            <TextBox
                                type="text" className="form-control"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                onEnter13={() => handleNext(1)}
                                placeholder="ชื่อ
                                "
                                style={{ width: '100%', padding: '8px', marginBottom: '20px' }}
                            />

                            <TextBox
                                type="text" className="form-control"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                onEnter13={() => handleNext(1)}
                                placeholder="นามสกุล"
                                style={{ width: '100%', padding: '8px', marginBottom: '20px' }}
                            />

                            {inviterInfo && (
                                <>
                                    <div className="row">
                                        <div className="col">
                                            เข้าร่วมห้องแชท
                                            <div className="alert alert-warning p-2">{companyName}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            รหัสเชิญ
                                            <div className="alert alert-warning p-2">{inviteCode}</div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {!inviterInfo && (
                                <>
                                    <TextBox
                                        type="text" className="form-control"
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                        onEnter13={() => handleNext(1)}
                                        placeholder="บริษัท"
                                        style={{ width: '100%', padding: '8px', marginBottom: '20px' }}
                                    />

                                    <TextBox
                                        type="text" className="form-control"
                                        value={groupInviteCode}
                                        onChange={(e) => setGroupInviteCode(e.target.value)}
                                        onEnter13={() => handleNext(1)}
                                        placeholder="รหัส ห้องแชท/เซลล์"
                                        style={{ width: '100%', padding: '8px', marginBottom: '20px' }}
                                    />
                                </>
                            )}




                            <div className="row">
                                <div className="col">
                                    <Button color="light" className="w-100 waves-effect waves-light" onClick={() => handleNext(-1)}>ย้อนกลับ</Button>
                                </div>

                                <div className="col">
                                    <Button color="primary" className="w-100 waves-effect waves-light" onClick={() => handleNext(1)}>เริ่มต้นใช้งาน</Button>
                                </div>
                            </div>
                        </motion.div>
                    )}

                    {isRegisterStage && (
                        <div className="mt-5 text-center text-muted">
                            <p>
                                มีบัญชีอยู่แล้ว ?{" "}
                                <Link
                                    to="/auth-login"
                                    className="fw-medium text-decoration-underline"
                                >
                                    ล็อกอิน
                                </Link>
                            </p>
                        </div>
                    )}
                    {!isRegisterStage && (
                        <div className="mt-5 text-center text-muted">
                            <p>
                                ยังไม่มีบัญชี ?{" "}
                                <Link
                                    to="/auth-register-phone?login=0"
                                    className="fw-medium text-decoration-underline"
                                >
                                    {" "}
                                    ลงทะเบียน
                                </Link>
                            </p>
                            {/* <p>
                                <Link to="/" className="fw-medium text-decoration-underline">
                                    หน้าแรก
                                </Link>
                            </p> */}
                        </div>
                    )}
                    {!isPWAInstalled() && (
                        <div className="mt-5 text-center text-muted">
                            <button id="btnInstallPwa" className="btn btn-danger" type="button" style={{ marginRight: "10px" }} onClick={() => installPwa()}>ติดตั้งแอป</button>
                        </div>
                    )}
                </Col>
            </Row>
        </NonAuthLayoutWrapper>
    );
}


export default RegisterByPhone;